import { FC } from 'react';
import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { ChartEmptyState } from '../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import styles from './AFIRadarChart.module.scss';

interface AFIRadarChartProps {
  componentA: number | null;
  componentB: number | null;
  componentC: number | null;
  height?: number;
  showComponentB?: boolean;
}

export const AFIRadarChart: FC<AFIRadarChartProps> = ({
  componentA,
  componentB,
  componentC,
  height = 240,
  showComponentB = true,
}) => {
  if (componentA === null && componentB === null && componentC === null) {
    return <ChartEmptyState />;
  }

  const data = [
    {
      subject: componentA === null ? 'Stabilità Fis. (N/D)' : 'Stabilità Fis.',
      fullMark: 100,
      value: componentA ?? 0,
    },
    {
      subject: !showComponentB
        ? 'Cap. Recovery *'
        : componentB === null
        ? 'Cap. Recovery (N/D)'
        : 'Cap. Recovery',
      fullMark: 100,
      value: showComponentB ? (componentB ?? 0) : 0,
    },
    {
      subject: componentC === null ? 'Margine Strutt. (N/D)' : 'Margine Strutt.',
      fullMark: 100,
      value: componentC ?? 0,
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Profilo AFI</div>
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data} margin={{ top: 8, right: 24, left: 24, bottom: 8 }}>
          <PolarGrid gridType="polygon" stroke="#e7e7e7" />
          <PolarAngleAxis
            dataKey="subject"
            tick={{ fill: '#4d4d4d', fontSize: 11, fontFamily: "'Satoshi', sans-serif" }}
          />
          <PolarRadiusAxis
            domain={[0, 100]}
            tickCount={5}
            tick={{ fill: '#4d4d4d', fontSize: 10, fontFamily: "'Satoshi', sans-serif" }}
            angle={90}
          />
          <Tooltip
            formatter={(value, name) => {
              if (!showComponentB && name === 'Cap. Recovery *') return ['N/D', name];
              return [value, name];
            }}
          />
          <Radar
            dataKey="value"
            fill="#5BC9E0"
            fillOpacity={0.2}
            stroke="#5BC9E0"
            strokeWidth={2}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};
